<div class="rfr_input-wrapper">
  <ion-item lines="none" [style]="style" [class]="class" [ngClass]="{
      'rfr_ion-item': !readonly,
      'rfr_ion-item_read-only': readonly,
      'rfr_ion-item_error': !readonly && required
        && (error || (controlDir?.errors && controlDir?.control?.touched && controlDir?.control?.dirty)),
      'rfr-size-normal': size === 'normal',
      'rfr-size-large': size === 'large',
    }">
    <div *ngIf="numbers && numbers.length" slot="start" style="display: flex; align-items: center; margin-right: 14px;">
      <!-- <img width="20" height="15" [src]="numberCode?.flag" alt="" style="margin-right: 6px; object-fit: cover;"> -->
      <ion-select [disabled]="disabled" (ionChange)="handleChange($event)" [value]="numberCode" interface="popover">
        <ion-select-option *ngFor="let number of numbers" [value]="number">
          <div style="display: flex; align-items: center; gap: 8px;">
            <!-- <img [src]="numberCode?.flag" /> -->
            <span style="color: #666;">{{number.country}} ({{ number.code }})</span>
          </div>
        </ion-select-option>
      </ion-select>
    </div>

    <div>
      <ng-content select=".icon-start"></ng-content>
    </div>
    <ion-input [ngClass]="{
      'rfr_input': true,
      'rfr_input_text-left': alignInputText === 'left',
      'rfr_input_text-right': alignInputText === 'right',
      'rfr_input_text-center': alignInputText === 'center',
      }" labelPlacement="floating" [type]="type" [(ngModel)]="displayValue"
      (input)="onChangeInput($any($event.target).value)" (ionBlur)="onBlur()" [disabled]="disabled"
      [readonly]="readonly" [placeholder]="placeholder" [pattern]="pattern" [min]="min" [max]="max"
      [maxlength]="maxLength">
      <div class="rfr-label-text" slot="label">{{ labelText }} <ion-text color="danger" *ngIf="required">*</ion-text>
      </div>
    </ion-input>
  </ion-item>
  <ng-content select="[slot=error-message]"></ng-content>
</div>
